// Aggiunge un nuovo wallet
const sanitizeMoneyInput = (value) => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  let normalized = String(value).trim();

  if (normalized === '') {
    return 0;
  }

  normalized = normalized.replace(/\s|'/g, '');

  const isNegative = normalized.startsWith('-');
  if (isNegative) {
    normalized = normalized.slice(1);
  }

  const lastComma = normalized.lastIndexOf(',');
  const lastDot = normalized.lastIndexOf('.');
  let decimalSeparator = null;

  if (lastComma === -1 && lastDot === -1) {
    decimalSeparator = null;
  } else if (lastComma === -1) {
    decimalSeparator = '.';
  } else if (lastDot === -1) {
    decimalSeparator = ',';
  } else {
    decimalSeparator = lastComma > lastDot ? ',' : '.';
  }

  const digitsOnly = normalized.replace(/[.,]/g, '');

  let normalizedNumber = digitsOnly;
  if (decimalSeparator) {
    const decimalIndex = decimalSeparator === '.' ? lastDot : lastComma;
    const decimalDigits = normalized.length - decimalIndex - 1;
    if (decimalDigits > 0) {
      const integerDigits = Math.max(digitsOnly.length - decimalDigits, 0);
      const integerPart = digitsOnly.slice(0, integerDigits) || '0';
      const decimalPart = digitsOnly.slice(integerDigits).padStart(decimalDigits, '0');
      normalizedNumber = `${integerPart}.${decimalPart}`;
    }
  }

  if (isNegative && normalizedNumber !== '0') {
    normalizedNumber = `-${normalizedNumber}`;
  }

  const parsed = Number.parseFloat(normalizedNumber);

  return Number.isFinite(parsed) ? parsed : 0;
};

export function addWallet(wallets, newWallet) {
  if (!newWallet || !newWallet.name || !newWallet.color || !newWallet.type) throw new Error('Conto non valido');
  if (wallets.some(w => w.name === newWallet.name)) throw new Error('Esiste già un conto con questo nome');
  // Genera sempre un nuovo id unico deterministico (come per le transazioni)
  const uniqueId = `${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
  return [...wallets, {
    ...newWallet,
    id: uniqueId,
    balance: sanitizeMoneyInput(newWallet.balance ?? newWallet.initialBalance ?? 0),
    initialBalance: sanitizeMoneyInput(newWallet.initialBalance)
  }];
}

// Modifica un wallet esistente per id
export function editWallet(wallets, id, updatedFields) {
  return wallets.map(w =>
    w.id === id ? { ...w, ...updatedFields, id: w.id } : w
  );
}

// Elimina un wallet per id
export function deleteWallet(wallets, id) {
  return wallets.filter(w => w.id !== id);
}

// Valida un wallet (nome e colore obbligatori)
export function validateWallet(wallet) {
  return !!wallet && !!wallet.name && !!wallet.color && !!wallet.type;
}

// Calcola il saldo di un wallet dato array di transazioni
export function calculateWalletBalance(wallet, expenses, incomes) {
  if (!wallet) return 0;
  // Gestisce sia i vecchi ID numerici che i nuovi ID stringa
  const totalIn = incomes.filter(i => i.walletId === wallet.id || i.walletId === wallet.name).reduce((sum, i) => sum + parseFloat(i.amount), 0);
  const totalOut = expenses.filter(e => e.walletId === wallet.id || e.walletId === wallet.name).reduce((sum, e) => sum + parseFloat(e.amount), 0);
  const baseBalance = wallet.initialBalance !== undefined ? wallet.initialBalance : wallet.balance;
  return baseBalance + totalIn - totalOut;
} 
